import {
  BatchInvitationCreatedBy,
  BatchInvitationDepartment,
  BatchInvitationProgressDetailsResponse,
  BatchInvitationProgressStatus,
} from '../types/screeningExternalApplicantsTypes';

const batchInvitationStatusKeyMap: Record<BatchInvitationProgressStatus, string> = {
  pending: 'pending',
  processing: 'processing',
  success: 'success',
  error: 'error',
};

export const getBatchInvitationStatusTranslationKey = (status: BatchInvitationProgressStatus) => {
  return batchInvitationStatusKeyMap[status] || 'unknown';
};

export const getLocalizedDepartment = (department: BatchInvitationDepartment, language: string) => {
  if (!department) return '-';

  return department[language as keyof NonNullable<BatchInvitationDepartment>] || department.en || department.de || '-';
};

export const getUserInitials = (createdBy: BatchInvitationCreatedBy) => {
  if (!createdBy) return '';
  const firstInitial = createdBy.firstName?.trim().charAt(0) || '';
  const lastInitial = createdBy.lastName?.trim().charAt(0) || '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export const hasCompletedWithIssues = (details?: BatchInvitationProgressDetailsResponse) => {
  if (!details || details.status !== 'error') return false;
  return (details.counters?.successRowsCount ?? 0) > 0;
};
